export default "__VITE_ASSET__017022e6__"